export const getBorrowerAction = (state = {}, action) => {
  switch (action.type) {
    case "GET_BORROWER_DETAILS":
      return action.data;

    default:
      return state;
  }
};
